// Purpose: Generates reusable, structural BayHive form and field compositions.
export const formLayoutStyles = ({ dt }) => `
html[data-ui-brand='bayhive'] .line-items-required-indicator {
  color: ${dt('danger.color')};
}

html[data-ui-brand='bayhive'] .bayhive-vin-row {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

html[data-ui-brand='bayhive'] .bayhive-vin-row > .p-inputtext {
  flex: 1 1 auto;
  min-width: 0;
}

html[data-ui-brand='bayhive'] .bayhive-vin-hint {
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;
  color: ${dt('text.muted.color')};
}

html[data-ui-brand='bayhive'] .bayhive-vin-hint--complete {
  color: ${dt('primary.color')};
}

html[data-ui-brand='bayhive'] :is(.bayhive-form-stack, .bayhive-field) {
  display: grid;
}

html[data-ui-brand='bayhive'] .bayhive-form-stack {
  align-content: start;
  gap: ${dt('bayhive.spacing.md')};
}

html[data-ui-brand='bayhive'] .bayhive-field {
  align-content: start;
  gap: ${dt('bayhive.spacing.xs')};
  min-width: 0;
}

html[data-ui-brand='bayhive'] .bayhive-field-control {
  display: flex;
  align-items: center;
  min-width: 0;
}

html[data-ui-brand='bayhive'] .bayhive-field-control--small {
  min-height: var(--p-button-sm-icon-only-width);
}

html[data-ui-brand='bayhive'] .bayhive-form-validation-message.p-message {
  position: sticky;
  z-index: 8;
  top: ${dt('bayhive.spacing.sm')};
  grid-column: 1 / -1;
}

html[data-ui-brand='bayhive'] :is(.bayhive-form-grid, .bayhive-form-card-grid) {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: ${dt('bayhive.spacing.md')};
}

html[data-ui-brand='bayhive'] .bayhive-form-grid--trailing-compact {
  grid-template-columns: minmax(0, 1fr) max-content;
}

html[data-ui-brand='bayhive'] .bayhive-form-grid--three-trailing-compact {
  grid-template-columns: repeat(2, minmax(0, 1fr)) max-content;
}

html[data-ui-brand='bayhive'] :is(.bayhive-form-actions, .bayhive-inline-field) {
  display: flex;
  align-items: center;
  gap: ${dt('bayhive.spacing.sm')};
}

html[data-ui-brand='bayhive'] .bayhive-form-actions {
  justify-content: flex-end;
}

html[data-ui-brand='bayhive'] .bayhive-inline-field > .p-inputgroup {
  flex: 1 1 auto;
  min-width: 0;
}

html[data-ui-brand='bayhive'] :is(
  .bayhive-field > label,
  .bayhive-field > legend,
  .bayhive-field > .bayhive-field-label,
  label.bayhive-inline-field
) {
  margin: 0;
}

@media (max-width: 1199px) {
  html[data-ui-brand='bayhive'] .bayhive-form-card-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 640px) {
  html[data-ui-brand='bayhive'] .bayhive-form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
`;

export default formLayoutStyles;
